// ============================================================
//  MASAMADREAM — Onboarding (primera visita)
//  Fase 5: 3 slides, se muestra solo la primera vez
// ============================================================

const KEY = 'mm_onboarded';

const SLIDES = [
  {
    emoji: '🌱',
    title: '¡Tu masa madre te necesita!',
    desc:  'MASAGOTCHI te guía paso a paso en el proceso de fermentación y preparación del pan artesanal.',
  },
  {
    emoji: '📋',
    title: 'Actividades diarias',
    desc:  'Cada día tiene sus tareas. Toca cualquier actividad para ver las instrucciones detalladas y márcalas al completar.',
  },
  {
    emoji: '🔔',
    title: 'Nunca te pierdas una alimentación',
    desc:  'Activa las notificaciones y te avisaremos exactamente cuándo actuar para que tu masa salga perfecta.',
  },
];

export function shouldOnboard() {
  return !localStorage.getItem(KEY);
}

export function markOnboarded() {
  localStorage.setItem(KEY, '1');
}

export function initOnboarding(onFinish) {
  const screen = document.getElementById('mm-screen-onboarding');
  if (!screen) { onFinish(); return; }

  let current = 0;

  const slideContainer = screen.querySelector('.mm-ob-slides');
  const dots           = screen.querySelectorAll('.mm-ob-dot');
  const btnNext        = screen.querySelector('#mm-ob-next');
  const btnSkip        = screen.querySelector('#mm-ob-skip');

  function goTo(idx) {
    current = idx;

    // Update slides
    screen.querySelectorAll('.mm-ob-slide').forEach((s, i) => {
      s.classList.toggle('is-active', i === idx);
    });

    // Update dots
    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));

    // Update button label
    const isLast = idx === SLIDES.length - 1;
    btnNext.textContent = isLast ? '¡Empezar! 🍞' : 'Siguiente →';
  }

  function finish() {
    markOnboarded();
    screen.classList.remove('is-active');
    onFinish();
  }

  btnNext.addEventListener('click', () => {
    if (current < SLIDES.length - 1) {
      goTo(current + 1);
    } else {
      finish();
    }
  });

  btnSkip.addEventListener('click', finish);

  // Touch swipe support
  let _sx = 0;
  slideContainer?.addEventListener('touchstart', e => { _sx = e.touches[0].clientX; }, { passive: true });
  slideContainer?.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - _sx;
    if (dx < -40 && current < SLIDES.length - 1) goTo(current + 1);
    if (dx >  40 && current > 0) goTo(current - 1);
  }, { passive: true });

  goTo(0);
}
